import React from 'react';
import { AdditionalPrice } from '../AdditionalPrice';
import { classNames } from '../../../utils/style';
export const InstallationLabel = ({
  installationLabel,
  displayEmptyLines,
  installationLineThrough,
}: any) => {
  return (
    <AdditionalPrice
      name="installationLabel"
      display={installationLabel}
      displayEmptyLines={displayEmptyLines}
      className={classNames(
        'extraPrice text-neutral-101 text-12 mb-24',
        installationLineThrough && 'line-through'
      )}
    >
      {installationLabel}
    </AdditionalPrice>
  );
};
